"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var Localize_1 = require("../../../gen-src/Localize");
var FlowUpstreamDatasourcesFilteredByFlowOutputFieldQueryGql_1 = require("../../queries/FlowUpstreamDatasourcesFilteredByFlowOutputFieldQueryGql");
var FlowUpstreamDatasourcesQueryGql_1 = require("../../queries/FlowUpstreamDatasourcesQueryGql");
var DatasourcesDisplayGrid_1 = require("../sharedDisplayGrid/DatasourcesDisplayGrid");
function selectConnectionListResult(resultData) {
    var flow = resultData && resultData.flows && resultData.flows[0];
    return flow ? flow.upstreamDatasourcesConnection : null;
}
function selectConnectionListResultForFilteredQuery(resultData) {
    var flow = resultData && resultData.flows && resultData.flows[0];
    var flowOutputFields = flow && flow.outputFieldsConnection && flow.outputFieldsConnection.nodes;
    var field = flowOutputFields && flowOutputFields[0];
    return field ? field.upstreamDatasourcesConnection : null;
}
function mapResultNode(node) {
    return {
        id: node.id,
        name: node.name,
        description: node.description || '',
        owner: node.owner,
        workbookCount: node.downstreamWorkbooksConnection ? node.downstreamWorkbooksConnection.totalCount : null,
        vizportalUrlId: node.vizportalUrlId,
        extractLastUpdateTime: node.extractLastUpdateTime || null,
        projectName: node.projectName,
        projectVizportalUrlId: node.projectVizportalUrlId,
        hasExtracts: !!node.hasExtracts,
        isCertified: node.isCertified,
        certifier: node.certifier,
        certificationNote: node.certificationNote || ''
    };
}
function FlowUpstreamDatasourcesQueryGrid(props) {
    var emptyGridMessage = Localize_1.Messages.EmptyUpstreamDatasourcesLineageGridMessage();
    var emptyFilteredGridMessage = Localize_1.Messages.EmptyUpstreamFilteredDatasourcesLineageGridMessage();
    return props.filteredFlowOutputFieldId ? (React.createElement(data_catalog_shared_1.PaginatedQueryWrapper, { queryGql: FlowUpstreamDatasourcesFilteredByFlowOutputFieldQueryGql_1.FlowUpstreamDatasourcesFilteredByFlowOutputFieldQueryGql, partialQueryVariables: {
            flowVizportalUrlId: props.flowVizportalUrlId,
            selectedFlowOutputFieldId: props.filteredFlowOutputFieldId,
            orderBy: props.orderBy,
        }, selectConnectionListResult: selectConnectionListResultForFilteredQuery, mapResultNode: mapResultNode }, function (_a) {
        var rowStore = _a.rowStore;
        return React.createElement(DatasourcesDisplayGrid_1.DatasourcesDisplayGrid, { rowStore: rowStore, emptyGridMessage: emptyFilteredGridMessage, rowCount: props.rowCount, orderBy: props.orderBy, updateSortOrder: props.updateSortOrder });
    })) : (React.createElement(data_catalog_shared_1.PaginatedQueryWrapper, { queryGql: FlowUpstreamDatasourcesQueryGql_1.FlowUpstreamDatasourcesQueryGql, partialQueryVariables: {
            flowVizportalUrlId: props.flowVizportalUrlId,
            orderBy: props.orderBy,
        }, selectConnectionListResult: selectConnectionListResult, mapResultNode: mapResultNode }, function (_a) {
        var rowStore = _a.rowStore;
        return React.createElement(DatasourcesDisplayGrid_1.DatasourcesDisplayGrid, { rowStore: rowStore, emptyGridMessage: emptyGridMessage, rowCount: props.rowCount, orderBy: props.orderBy, updateSortOrder: props.updateSortOrder });
    }));
}
exports.FlowUpstreamDatasourcesQueryGrid = FlowUpstreamDatasourcesQueryGrid;
//# sourceMappingURL=FlowUpstreamDatasourcesQueryGrid.js.map